<template>
    <div class="card">
        <slot name="title"></slot>
        <div class="card-content" >
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
import Title from "@/components/Title.vue";
export default {
    components: {
        Title
    },
    props: {
        font_size: {
            type: String,
            default: '1.5rem'
        },
        header_background: {
            type: String,
            default: '#cfefff'
        },
        subtitle: String,
        title: String,
    }
}
</script>

<style scoped>
.card {
    margin: 2rem auto;
    border-radius: 4px;
}

.card-content {
    font-size: 1.3rem;
    text-align: justify;
}

.card-content p, li {
    margin-bottom: 1rem;
}

.card-header {
    border-radius: 4px;
    margin: auto;
    padding: 0.25rem;
}

.card-header-title {
  color: #000;
    font-weight: 300;
}

.transparent {
    opacity: 0.98;
}
</style>